import { INITIAL_STATUS } from "../initial-state";
import type { GlobalStore } from "../store";

const systemStatus = (s: GlobalStore) => s.status;
const showHeader = (s: GlobalStore) =>
  systemStatus(s).showHeader ?? INITIAL_STATUS.showHeader;
const showSidebar = (s: GlobalStore) =>
  systemStatus(s).showSidebar ?? INITIAL_STATUS.showSidebar;
const sideBarStyle = (s: GlobalStore) => systemStatus(s).sideBarStyle;

export const systemStatusSelectors = {
  sideBarStyle,
  showHeader,
  showSidebar,
  systemStatus,
};
